import React, { useState, useEffect } from "react";
import { NavLink, useParams, Link } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import {
  getAnalysisRegionList,
  getAnalysisCountriesList,
  getAnalysisProfessionList,
  analysisLandingData,
  getAnalysisChartData,
  submitFormData,
  saveSurveyAnalysisReport,
} from "../../Utils/adminFunctions";
import { getDataArr } from "../../Utils/commonFunctions";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import { Bar } from "react-chartjs-2";
import { MultiSelect } from "react-multi-select-component";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const AdminCreateAnalysis = () => {
  const { surveyID } = useParams(); ///survey ID
  const [listRegions, setListRegions] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [listCountries, setListCountries] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [listProfession, setListProfession] = useState([]);
  const [selectedProfession, setSelectedProfession] = useState([]);
  const [currentItems, setCurrentItems] = useState(1);
  const [totalRecords, setTotalRecords] = useState();
  const [tempQuestionID, setTempQuestionID] = useState("");
  const [tempQuestionNo, setTempQuestionNo] = useState("");
  const [tempQuestionText, setTempQuestionText] = useState("");
  const [tempChartNo, setTempChartNo] = useState("");
  const [tempSaveButtonShow, setTempSaveButtonShow] = useState("hide");
  const [tempReportButtonText, setTempReportButtonText] = useState("");
  const [chartData, setChartData] = useState([]);
  const [surveyStatus, setSurveyStatus] = useState("");
  const [chartBase64Content, setChartBase64Content] = useState([]);
  const [surveyType, setSurveyType] = useState("");
  const [surveyLabel, setSurveyLabel] = useState("");
  const [title, setTitle] = useState("");
  const [hideBar, setHideBar] = useState(0);
  const labels = [""];
  useEffect(() => {
    getSurveyData(currentItems);
    getSurveyRegion();
  }, []);
  const getSurveyData = async (currentItems) => {
    const response = await analysisLandingData(surveyID, currentItems);
    if (response.status == "success") {
      setTotalRecords(response.data["total_records"]);
      setTempQuestionID(response.data["question_id"]);
      setTempQuestionText(response.data["label"]);
      setSurveyType(response.data["question_type"]);
      setSurveyLabel(response.data["survey_label"]);

      setTempChartNo(response.data["no_of_charts"]);
      setTempQuestionNo(response.data["question_no"]);
      setSurveyStatus(response.data["survey_status"]);
      if (response.data["isAnalysis"] === 0) {
        setTempReportButtonText("Create");
      } else {
        setTempReportButtonText("Update");
      }
    } else {
      toast.error(response.message, { autoClose: 1500 });
    }
  };
  const getSurveyRegion = async () => {
    try {
      const response = await getAnalysisRegionList(surveyID);
      setListRegions(response.optionItems);
    } catch (error) {
      setListRegions([]);
    }
  };
  const getCountryByRegion = async (regions) => {
    try {
      const bodyFormData = new FormData();
      let regionSelectedArr = getDataArr(regions);
      bodyFormData.append("survey_id", surveyID);
      bodyFormData.append("region", regionSelectedArr);
      const response = await getAnalysisCountriesList(bodyFormData);
      setListCountries(response?.optionItems || []);
    } catch (error) {
      setListCountries([]);
    }
  };

  const getProfessionByRegion = async (regions) => {
    try {
      const bodyFormData = new FormData();
      let regionSelectedArr = getDataArr(regions);
      bodyFormData.append("survey_id", surveyID);
      bodyFormData.append("region", regionSelectedArr);
      const response = await getAnalysisProfessionList(bodyFormData);
      setListProfession(response?.optionItems || []);
    } catch (error) {
      setListProfession([]);
    }
  };
  const getProfessionByRegionAndCountry = async (country) => {
    try {
      const bodyFormData = new FormData();
      let regionSelectedArr = getDataArr(selectedRegions);
      let countrySelectedArr = getDataArr(country);
      bodyFormData.append("survey_id", surveyID);
      bodyFormData.append("region", regionSelectedArr);
      bodyFormData.append("country", countrySelectedArr);
      const response = await getAnalysisProfessionList(bodyFormData);
      setListProfession(response?.optionItems || []);
    } catch (error) {
      setListProfession([]); 
    }
  }; 
  const handleFilter = async () => {
    setHideBar(0);
    if (
      selectedRegions.length == 0 &&
      selectedCountries.length == 0 &&
      selectedProfession.length == 0
    ) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      return false;
    }
    const bodyFormData = new FormData();
    let selectedRegionsArr = getDataArr(selectedRegions);
    let selectedCountriesArr = getDataArr(selectedCountries);
    let selectedProfessionArr = getDataArr(selectedProfession);
    bodyFormData.append("survey_id", surveyID);
    bodyFormData.append("question_id", tempQuestionID);
    bodyFormData.append("action", "filter");
    bodyFormData.append("region_filters", selectedRegionsArr);
    bodyFormData.append("country_filters", selectedCountriesArr);
    bodyFormData.append("profession_filters", selectedProfessionArr);
    const response = await getAnalysisChartData(bodyFormData);
    if (response.status === "success") {
      let tmpArr = Object.values(response.data.datasets);
      if (tmpArr.length > 0) {
        setTitle(response.data.title);
        setChartData(tmpArr);
        setTimeout(function () {
          let url_base64jp = document
            .getElementById("barChart")
            .toDataURL("image/png");
          setChartBase64Content(url_base64jp);
        }, 1000);
        setTempSaveButtonShow("show");
      } else {
        setHideBar(1);
        setTitle([]);
        setChartData([]);
        setChartBase64Content([]);
      }
    } else {
      toast.error(response, { autoClose: 1500 });
    }
  };

  const handleSave = async () => {
    setHideBar(1);
    let selectedRegionsArr = getDataArr(selectedRegions);
    let selectedCountriesArr = getDataArr(selectedCountries);
    let selectedProfessionArr = getDataArr(selectedProfession);
    const bodyFormData = new FormData();
    bodyFormData.append("survey_id", surveyID);
    bodyFormData.append("question_id", tempQuestionID);
    bodyFormData.append("action", "save_graph");
    bodyFormData.append("region_filters", selectedRegionsArr);
    bodyFormData.append("country_filters", selectedCountriesArr);
    bodyFormData.append("profession_filters", selectedProfessionArr);
    bodyFormData.append("graph_image", chartBase64Content);
    const response = await submitFormData("saveAnalysisGraph", bodyFormData);
    if (response.status == "success") {
      getSurveyData(currentItems);
      setChartData([]);
      setTempSaveButtonShow("hide");
      setSelectedCountries([]);
      setSelectedProfession([]);
      setListCountries([]);
      setListProfession([]);
      setTitle("");
      toast.success(response.message, { autoClose: 1500 });
    }
    if (response.status == "failure") {
      toast.warning(response.message, { autoClose: 1500 });
    }
    if (response.status == "error") {
      toast.error(response.message, { autoClose: 1500 });
    }
  };
  const options = {
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: title ? title : "",
        padding: {
          top: 10,
          bottom: 10,
        },
        color: "#0069d9",
      },
      scales: {
        xaxis: {
          beginAtZero: true,
          ticks: {
            stepSize: 1.0,
          },
        },
      },
    },
  };

  const handleClickPagination = (item) => {
    setHideBar(1);
    setCurrentItems(item);
    setChartData([]);
    setTempSaveButtonShow("hide");
    setSelectedRegions([]);
    setSelectedCountries([]);
    setSelectedProfession([]);
    getSurveyData(item);
    setSelectedCountries([]);
    setSelectedProfession([]);
    setListCountries([]);
    setListProfession([]);
  };

  const handleReportSubmit = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append("survey_id", surveyID);
    const response = await saveSurveyAnalysisReport(bodyFormData);
    if (response.status === "success") {
      setTempReportButtonText("Update");
      toast.success(response.message, { autoClose: 1500 });
    } else {
      toast.error(response.message, { autoClose: 1500 });
    }
  };

  function PaginatedItems() {
    const items = Array.from({ length: totalRecords }, (x, i) => i);
    let tempList = items.map((item, i) => (
      <li
        className={item == currentItems - 1 ? "page-item active" : "page-item "}
        key={i}
      >
        <NavLink
          to="#"
          className="page-link"
          onClick={() => {
            handleClickPagination(item);
          }}
        >
          {++item}
        </NavLink>
      </li>
    ));

    return (
      <nav aria-label="Page navigation example">
        <ul className="pagination">{tempList}</ul>
      </nav>
    );
  }
  /* pagination code */
  function getData() {
    let tmpReturnData = {
      labels,
      datasets: chartData,
    };                                                                                                                                                                                                                                                          
    return tmpReturnData;
  }
  return (
    <div>
      
      <div className="wrapper">
        <div>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row mb-2">
                  <div className="col-md-6"></div>
                  <div className="col-md-6">
                    <Link
                      to={"/AdminSurveyDetails/" + surveyID}
                      className="btn btn-sm custom-btn-primary pull-right"
                    >
                      <i className="fa fa-arrow-left"></i> Back
                    </Link>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Region
                              </span>
                              <MultiSelect
                                options={listRegions}
                                value={selectedRegions}
                                onChange={(e) => {
                                  // getProfessionByRegion(e);
                                  setSelectedRegions(e);
                                  getCountryByRegion(e);
                                }}
                                labelledBy="Select"
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Country
                              </span>
                              <MultiSelect
                                options={listCountries}
                                value={selectedCountries}
                                onChange={(e) => {
                                  getProfessionByRegionAndCountry(e);
                                  setSelectedCountries(e);
                                }}
                                labelledBy="Select"
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Profession
                              </span>

                              <MultiSelect
                                options={listProfession}
                                value={selectedProfession}
                                onChange={setSelectedProfession}
                                labelledBy="Select"
                              />
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                .
                              </span>
                              <br></br>
                              <button
                                className="btn btn-block custom-btn-primary btn-xs"
                                onClick={handleFilter}
                              >
                                Apply Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-default">
                      <div className="card-header">
                        <div>
                          <button className="btn btn-sm custom-btn-primary">
                            {tempQuestionNo}
                          </button>{" "}
                          {tempQuestionText}
                          {surveyType === "survey" ? " > " + surveyLabel : ""}
                        </div>
                      </div>

                      <div className="card-body create-graph-box-height">
                        <div className="row">
                          <div className="col-md-10">
                            {hideBar == 0 && (
                              <Bar
                                id="barChart"
                                options={options}
                                data={getData()}
                                height={60}
                              />
                            )}
                          </div>
                          <div className="col-md-2">
                            <p className="text-right chart-no">
                              No of Charts: {tempChartNo}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="card-footer">
                        <span className="pull-right">{<PaginatedItems />}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <button
                      className={
                        "btn btn-sm custom-btn-primary" +
                        (tempSaveButtonShow === "hide" ? " hidden-custom" : "")
                      }
                      onClick={handleSave}
                    >
                      Save
                    </button>{" "}
                    <Link
                      className="btn btn-sm custom-btn-primary"
                      to={
                        "/AdminAnalysisPreview/" +
                        surveyID +
                        "/" +
                        tempQuestionID +
                        "/" +
                        currentItems
                      }
                    >
                      Preview
                    </Link>
                  </div>
                  <div className="col-md-6">
                    {(totalRecords === currentItems || totalRecords === 1) && (
                      <>
                        {(surveyStatus === "final_save" ||
                          surveyStatus === "completed") && (
                          <button
                            className="btn btn-sm custom-btn-primary pull-right"
                            onClick={handleReportSubmit}
                          >
                            {tempReportButtonText} Survey Analysis Report
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminCreateAnalysis;
